import { Navigate, useLocation } from 'react-router-dom';
import { useAppAuth } from '@/providers/use-app-auth';
import { LoadingScreen } from '@/components/ui/loading-screen';
import { USE_MOCK_DATA } from '@/config/app.config';
import type { ReactNode } from 'react';

interface ProtectedRouteProps {
  children: ReactNode;
}

/**
 * Guard de rota — redireciona para login se não autenticado
 */
export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading } = useAppAuth();
  const location = useLocation();

  if (USE_MOCK_DATA) {
    return <>{children}</>;
  }

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
